/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-14 14:27:39
 */

import * as request from '@/utils/request'
const BASE_URL = 'api'

export default {


   /**
   * createBackRoles
   * @description 角色 新增
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createBackRoles(data) {
    return request.post(`${BASE_URL}/roles/store`, data)
  },

  /**
   * updateBackRoles
   * @description 角色 编辑
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateBackRoles(id, data) {
    return request.put(`${BASE_URL}/roles/update/${id}`, data)
  },

  /**
   * getBackRolesList
   * @description 角色 列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getBackRolesList(data){
    return request.post(`${BASE_URL}/roles/list`, data)
  },

  /**
   * viewBackRoles
   * @description 角色 详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  viewBackRoles(data){
    return request.get(`${BASE_URL}/roles/view/${data}`)
  },

   /**
   * deleteBackRoles
   * @description 角色 详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  deleteBackRoles(data) {
    return request.Delete(`${BASE_URL}/roles/delete/${data}`)
  },

    /**
   * getPermissionsRoles
   * @description 角色  角色绑定
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getPermissionsRoles(data){
    return request.get(`${BASE_URL}/roles/get_permissions/${data}`)
  },

   /**
   * getUsersRoles
   * @description 获取当前角色下的用户列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getUsersRoles(data) {
    return request.get(`${BASE_URL}/roles/get_users`, data)
  },

  /**
   * removeRolesUser
   * @description 移除当前角色的用户
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  removeRolesUser(data) {
    return request.post(`${BASE_URL}/roles/remove_user`, data)
  },

  /**
   * rolesPermissions
   * @description 获取当前 角色的权限列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  rolesPermissions(data) {
    return request.get(`${BASE_URL}/roles/get_permissions/${data}`)
  },

  /**
   * @description 保存角色对应的权限
   * @author YM
   * @date 2019-01-26
   * @param {*} data
   * @returns
   */
  saveRolesPermissions(data) {
    return request.post(`${BASE_URL}/roles/save_permissions`, data)
  },

   /**
   * @description 角色 删除
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  deleteRoles(data){
    return request.Delete(`${BASE_URL}/roles/delete/${data}`)
  },

  /**
   * @description 获取服务公司列表
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getTenantList(){
    return request.get(`${BASE_URL}/tenant/list`)
  },

  /**
   * @description 获取服务公司详情-中台
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  tenantDetail() {
    return request.get(`${BASE_URL}/tenant/detail`)
  },





}